"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
exports.__esModule = true;
exports.planets = exports.synastryModes = exports.relocationsModes = exports.prognosticsModes = exports.aspects = exports.signs = exports.astroObjects = exports.houseNames = exports.hSysCodes = exports.elements = exports.allAspects = exports.majorAspects = exports.dispositors = exports.controllers = exports.significators = void 0;
var defs_1 = require("./defs");
exports.significators = (_a = {},
    _a[defs_1.ObjectType.Sun] = [4, 0],
    _a[defs_1.ObjectType.Moon] = [3, 0],
    _a[defs_1.ObjectType.Mercury] = [2],
    _a[defs_1.ObjectType.Venus] = [1, 6],
    _a[defs_1.ObjectType.Mars] = [7],
    _a[defs_1.ObjectType.Jupiter] = [8, 11],
    _a[defs_1.ObjectType.Saturn] = [9],
    _a[defs_1.ObjectType.Uranus] = [10],
    _a[defs_1.ObjectType.Neptune] = [8, 11],
    _a[defs_1.ObjectType.Pluto] = [7],
    _a);
exports.controllers = (_b = {},
    _b[defs_1.ObjectType.Sun] = [defs_1.SignType.Leo, defs_1.SignType.Cancer],
    _b[defs_1.ObjectType.Moon] = [defs_1.SignType.Leo, defs_1.SignType.Cancer],
    _b[defs_1.ObjectType.Mercury] = [defs_1.SignType.Gemini, defs_1.SignType.Virgo],
    _b[defs_1.ObjectType.Venus] = [defs_1.SignType.Taurus, defs_1.SignType.Libra],
    _b[defs_1.ObjectType.Mars] = [defs_1.SignType.Aries, defs_1.SignType.Scorpio],
    _b[defs_1.ObjectType.Jupiter] = [defs_1.SignType.Pisces, defs_1.SignType.Sagittarius],
    _b[defs_1.ObjectType.Saturn] = [defs_1.SignType.Capricorn, defs_1.SignType.Aquarius],
    _b[defs_1.ObjectType.Uranus] = [defs_1.SignType.Capricorn, defs_1.SignType.Aquarius],
    _b[defs_1.ObjectType.Neptune] = [defs_1.SignType.Pisces, defs_1.SignType.Sagittarius],
    _b[defs_1.ObjectType.Pluto] = [defs_1.SignType.Scorpio, defs_1.SignType.Aries],
    _b);
exports.dispositors = (_c = {},
    _c[defs_1.SignType.Aries] = [defs_1.ObjectType.Mars, defs_1.ObjectType.Pluto],
    _c[defs_1.SignType.Taurus] = [defs_1.ObjectType.Venus],
    _c[defs_1.SignType.Gemini] = [defs_1.ObjectType.Mercury],
    _c[defs_1.SignType.Cancer] = [defs_1.ObjectType.Moon, defs_1.ObjectType.Sun],
    _c[defs_1.SignType.Leo] = [defs_1.ObjectType.Sun, defs_1.ObjectType.Moon],
    _c[defs_1.SignType.Virgo] = [defs_1.ObjectType.Mercury],
    _c[defs_1.SignType.Libra] = [defs_1.ObjectType.Venus],
    _c[defs_1.SignType.Scorpio] = [defs_1.ObjectType.Pluto, defs_1.ObjectType.Mars],
    _c[defs_1.SignType.Sagittarius] = [defs_1.ObjectType.Jupiter, defs_1.ObjectType.Neptune],
    _c[defs_1.SignType.Capricorn] = [defs_1.ObjectType.Saturn, defs_1.ObjectType.Uranus],
    _c[defs_1.SignType.Aquarius] = [defs_1.ObjectType.Uranus, defs_1.ObjectType.Saturn],
    _c[defs_1.SignType.Pisces] = [defs_1.ObjectType.Neptune, defs_1.ObjectType.Jupiter],
    _c);
exports.majorAspects = [
    defs_1.AspectType.Conjunction,
    defs_1.AspectType.Sextile,
    defs_1.AspectType.Square,
    defs_1.AspectType.Trine,
    defs_1.AspectType.Opposition
];
exports.allAspects = [
    defs_1.AspectType.Conjunction,
    defs_1.AspectType.Semisextile,
    defs_1.AspectType.Semiquintile,
    defs_1.AspectType.Novile,
    defs_1.AspectType.Semisquare,
    defs_1.AspectType.Sextile,
    defs_1.AspectType.Quintile,
    defs_1.AspectType.Binovile,
    defs_1.AspectType.Square,
    defs_1.AspectType.MinusOrPlus,
    defs_1.AspectType.Tredecile,
    defs_1.AspectType.Trine,
    defs_1.AspectType.Sesquiquadrate,
    defs_1.AspectType.Biquintile,
    defs_1.AspectType.Quincunx,
    defs_1.AspectType.Opposition
];
exports.elements = (_d = {},
    _d[defs_1.ElementType.Land] = [defs_1.SignType.Taurus, defs_1.SignType.Virgo, defs_1.SignType.Capricorn],
    _d[defs_1.ElementType.Air] = [defs_1.SignType.Gemini, defs_1.SignType.Libra, defs_1.SignType.Aquarius],
    _d[defs_1.ElementType.Water] = [defs_1.SignType.Cancer, defs_1.SignType.Scorpio, defs_1.SignType.Pisces],
    _d[defs_1.ElementType.Fire] = [defs_1.SignType.Aries, defs_1.SignType.Leo, defs_1.SignType.Sagittarius],
    _d);
exports.hSysCodes = (_e = {},
    _e[defs_1.HousesSystem.Placidus] = 80,
    _e[defs_1.HousesSystem.Koch] = 75,
    _e[defs_1.HousesSystem.Regiomontanus] = 82,
    _e[defs_1.HousesSystem.Equal] = 65,
    _e[defs_1.HousesSystem.Porphyrius] = 79,
    _e);
exports.houseNames = [
    'Asc',
    'II',
    'III',
    'IC',
    'V',
    'VI',
    'Dsc',
    'VIII',
    'IX',
    'MC',
    'XI',
    'XII'
];
exports.astroObjects = (_f = {},
    _f[defs_1.ObjectType.Sun] = {
        ru: "astro.planets.sun",
        en: 'Sun',
        icon: 'M32 27.8a4.2 4.2 0 1 0 4.2 4.2 4.2 4.2 0 0 0-4.2-4.2z M32 9a23 23 0 1 0 23 23A23 23 0 0 0 32 9zm0 42a19 19 0 1 1 19-19 19 19 0 0 1-19 19z'
    },
    _f[defs_1.ObjectType.Moon] = {
        ru: "chronos.auth.planets.moon.title",
        en: 'Moon',
        icon: 'M26.35 9.37a22.62 22.62 0 0 0-6.7 1l-3.88 1.21 3.32 2.34a21.77 21.77 0 0 1 9.39 17.7 21.71 21.71 0 0 1-10.07 18.16L15 52l3.82 1.34a22.38 22.38 0 0 0 7.51 1.29 22.63 22.63 0 0 0 0-45.26zm0 41.26a18 18 0 0 1-2.35-.15 25.49 25.49 0 0 0 8.45-18.85 25.58 25.58 0 0 0-7.75-18.19c.54 0 1.08-.07 1.62-.07a18.63 18.63 0 0 1 0 37.26z'
    },
    _f[defs_1.ObjectType.Mercury] = {
        ru: "chronos.auth.planets.mercury.title",
        en: 'Mercury',
        icon: 'M46.86 13.2L44 10.38l-4.18 4.17a13.45 13.45 0 0 0-16.11-.73L20 10.05l-2.83 2.83 3.64 3.63a14.25 14.25 0 0 0-3.24 9.08 14 14 0 0 0 11.87 14v3.77h-6.65v4h6.62V54h4v-6.68H40v-4h-6.59v-3.8a14 14 0 0 0 11.66-13.93 14.27 14.27 0 0 0-2.5-8.09zM31.3 35.7a10 10 0 0 1-9.76-10.11 10 10 0 0 1 9.76-10.1 10 10 0 0 1 9.77 10.1A10 10 0 0 1 31.3 35.7z'
    },
    _f[defs_1.ObjectType.Venus] = {
        ru: "chronos.auth.planets.venus.title",
        en: 'Venus',
        icon: 'M45.77 24.87A13.94 13.94 0 0 0 32 10.77a13.94 13.94 0 0 0-13.77 14.1 14 14 0 0 0 11.88 14v3.73h-6.63v4h6.63v6.63h4V46.6h6.63v-4h-6.63v-3.8a14 14 0 0 0 11.66-13.93zm-23.54 0A10 10 0 0 1 32 14.77a10 10 0 0 1 9.77 10.1A10 10 0 0 1 32 35a10 10 0 0 1-9.77-10.13z'
    },
    _f[defs_1.ObjectType.Mars] = {
        ru: "astro.planets.mars",
        en: 'Mars',
        icon: 'M49.72 20.75l3.66-10.88-10.87 3.66 2.19 2.19-5.7 5.75a17.39 17.39 0 0 0-10.59-3.61A18 18 0 0 0 10.62 36a18 18 0 0 0 17.76 18.13A18 18 0 0 0 46.13 36a18.31 18.31 0 0 0-4.26-11.78l5.65-5.67zM28.38 50.13a14.14 14.14 0 0 1 0-28.27 14.14 14.14 0 0 1 0 28.27z'
    },
    _f[defs_1.ObjectType.Jupiter] = {
        ru: "chronos.auth.planets.jupiter.title",
        en: 'Jupiter',
        icon: 'M46.5 39.9V9.2h-3.8v30.7h-5.4c.3-.7.6-1.3.9-2 .6-1.2 1.1-2.4 1.6-3.6 1.8-4.3 1.2-9.6-1.5-13.4 0-.1-.1-.1-.1-.1-2.6-3.7-7.1-6-11.8-6.1-1.6 0-3.1.2-4.5.7-5.9 1.8-10 7.5-9.9 13.5 0 .5.2 1 .6 1.3.7.7 1.9.7 2.7 0 .4-.4.6-.9.6-1.3-.1-4.3 3.2-8.6 7.3-9.9 4.2-1.5 9.5.3 12.1 4 1.9 2.7 2.4 6.6 1.2 9.8v.2l-1.2 2.7-1.8 4.2H12v3.8h30.7v11.2h3.8V43.7H52v-3.8h-5.5z'
    },
    _f[defs_1.ObjectType.Saturn] = {
        ru: "chronos.auth.planets.saturn.title",
        en: 'Saturn',
        icon: 'M45.26 49.06a3.5 3.5 0 0 1-3.26 2c-1.71 0-3.54-1.13-3.54-4.28 0-2.8 1.19-4.62 2.56-6.73s3-4.58 3-8A12.36 12.36 0 0 0 23.4 22.7v-4.65h4.38v-4h-4.4V8.91h-4v5.14H15v4h4.38v26.12h4V31.79a8.11 8.11 0 0 1 8.31-8.27A8.23 8.23 0 0 1 40 32c0 2.28-1.08 3.95-2.34 5.87-1.5 2.31-3.2 4.93-3.2 8.91 0 5.68 3.91 8.27 7.53 8.28a7.39 7.39 0 0 0 7-4.61z'
    },
    _f[defs_1.ObjectType.Uranus] = {
        ru: "chronos.auth.planets.uranus.title",
        en: 'Uranus',
        icon: 'M51.79 10.47l-1.53-1.28-1.54-1.28a29.9 29.9 0 0 0-6.08 15.42h-8.45v-7.74h-4v7.74H21A31 31 0 0 0 15.37 8l-3.16 2.45a27 27 0 0 1 4.84 14.91 27.25 27.25 0 0 1-4.84 14.91l3.16 2.44A31 31 0 0 0 21 27.33h9.21V33a11.62 11.62 0 1 0 4 0v-5.67h8.45a29.9 29.9 0 0 0 6.08 15.41l3.07-2.56a25.84 25.84 0 0 1-5.23-14.85 25.89 25.89 0 0 1 5.21-14.86zm-12 34a7.63 7.63 0 1 1-7.63-7.63 7.64 7.64 0 0 1 7.65 7.62z'
    },
    _f[defs_1.ObjectType.Neptune] = {
        ru: "chronos.auth.planets.neptune.title",
        en: 'Neptune',
        icon: 'M49.85 16.68l-4.13-7.5-4.13 7.5h2.09v10.94c0 6.38-4.2 11.69-9.71 12.75V24.93h2.14L32 17.43l-4.13 7.5H30v15.44c-5.5-1.06-9.71-6.37-9.71-12.75V16.68h2.15l-4.13-7.5-4.13 7.5h2.11v10.94c0 8.61 6 15.73 13.71 16.8v1.27h-5.16v4H30v5.13h4v-5.13h5.1v-4H34v-1.27c7.72-1.07 13.71-8.19 13.71-16.8V16.68z'
    },
    _f[defs_1.ObjectType.Pluto] = {
        ru: "chronos.auth.planets.pluto.title",
        en: 'Pluto',
        icon: 'M47.78 21.31h-4A12 12 0 0 1 32 33.42a12 12 0 0 1-11.78-12.11h-4A16 16 0 0 0 30 37.28v4.91h-6.63v4H30v6.61h4v-6.61h6.63v-4H34v-4.91a16 16 0 0 0 13.78-15.97z M32 29.57a9.19 9.19 0 1 0-9.15-9.19A9.17 9.17 0 0 0 32 29.57zm0-14.37a5.19 5.19 0 1 1-5.15 5.18A5.17 5.17 0 0 1 32 15.2z'
    },
    _f[defs_1.ObjectType.NorthNode] = {
        ru: "astro.northNode",
        en: 'NorthNode',
        icon: 'M49 38.07a18.5 18.5 0 0 0 1.17-6.47 18.13 18.13 0 1 0-36.26 0 18.54 18.54 0 0 0 1.17 6.47 6.39 6.39 0 1 0 5.84 2.4A14.4 14.4 0 0 1 32 17.24 14.26 14.26 0 0 1 46.14 31.6a14.43 14.43 0 0 1-2.89 8.69 6.3 6.3 0 0 0-1.5 4.1A6.38 6.38 0 1 0 49 38.07zm-33.1 8.69a2.38 2.38 0 1 1 2.38-2.37 2.37 2.37 0 0 1-2.41 2.37zm32.26 0a2.38 2.38 0 0 1-2.38-2.37 2.35 2.35 0 0 1 .53-1.48 2.37 2.37 0 1 1 1.81 3.9z'
    },
    _f[defs_1.ObjectType.SouthNode] = {
        ru: "astro.southNode",
        en: 'SouthNode',
        icon: 'M15 25.93a18.5 18.5 0 0 0-1.17 6.47 18.13 18.13 0 1 0 36.26 0A18.54 18.54 0 0 0 49 25.93a6.39 6.39 0 1 0-5.84-2.4A14.4 14.4 0 0 1 32 46.76 14.26 14.26 0 0 1 17.86 32.4a14.43 14.43 0 0 1 2.89-8.69 6.3 6.3 0 0 0 1.5-4.1A6.38 6.38 0 1 0 15 25.93zm33.1-8.69a2.38 2.38 0 1 1-2.38 2.37 2.37 2.37 0 0 1 2.41-2.37zm-32.26 0a2.38 2.38 0 0 1 2.38 2.37 2.35 2.35 0 0 1-.53 1.48.1.1 0 0 0 0 .05 2.37 2.37 0 1 1-1.81-3.9z'
    },
    _f[defs_1.ObjectType.Lilith] = {
        ru: "astro.lilith",
        en: 'Lilith',
        icon: 'M36.16,41.13a18.31,18.31,0,0,0,5.66-.89L46,38.89l-3.8-2.27c-4.46-2.65-7.12-7-7.12-11.62s2.42-8.62,6.63-11.33l3.73-2.4-4.27-1.2a18.6,18.6,0,0,0-5.05-.7C26.68,9.37,19,16.49,19,25.25,19,31.94,23.48,37.67,29.84,40v5H23.2v4h6.64v6.62h4V49h6.63V45H33.84V41A17.72,17.72,0,0,0,36.16,41.13Z'
    },
    _f[defs_1.ObjectType.Chiron] = {
        ru: "astro.chiron",
        en: 'Chiron',
        icon: 'M33.94 31.82v-6.94L40.15 31l2.79-2.86-6.71-6.58 6.69-6.63L40.1 12l-6.16 6.1V9.87h-4v22a11.29 11.29 0 0 0 2 22.31 11.29 11.29 0 0 0 2-22.31zm-2 18.31a7.27 7.27 0 0 1 0-14.51 7.27 7.27 0 0 1 0 14.51z'
    },
    _f[defs_1.ObjectType.Selena] = {
        ru: "astro.selena",
        en: 'Selena',
        icon: 'M 4.37814 13.7268 C 3.5228900000000003 13.7268 2.67652 13.5971 1.8699999999999992 13.3463 L 0 12.7583 L 1.6883 11.7769 C 3.6602700000000006 10.6312 4.839 8.75054 4.839 6.75313 C 4.839 4.81193 3.7666199999999996 3.02637 1.9009999999999998 1.85906 L 0.24370000000000047 0.821445 L 2.13589 0.298315 C 2.8582 0.099439 3.6115200000000005 0 4.37371 0 C 8.57903 0 12 3.07825 12 6.86554 C 12 9.75789 9.99705 12.2352 7.1743 13.2425 L 7.1743 15.4086 L 10.12113 15.4086 L 10.12113 17.1379 L 7.1743 17.1379 L 7.1743 20 L 5.40177 20 L 5.40177 17.1379 L 2.4682399999999998 17.1379 L 2.4682399999999998 15.4086 L 5.40177 15.4086 L 5.40177 13.6576 C 5.06942 13.6965 4.72821 13.7268 4.37814 13.7268 Z M 10.23191 6.86122 C 10.23191 4.06398 7.6706 1.78556 4.50221 1.72936 C 5.84933 3.12581 6.61595 4.90272 6.61595 6.75313 C 6.61595 8.71595 5.76957 10.575 4.28951 11.9974 C 4.6706 12.0017 5.04727 11.9715 5.41063 11.9153 L 5.41063 11.885 L 5.57459 11.885 C 8.21122 11.4008 10.23191 9.3342 10.23191 6.86122 Z'
    },
    _f[15] = {
        ru: "astro.eris",
        en: 'Eris',
        icon: 'M11 2H13V6.70848C13.1102 6.58351 13.2246 6.46166 13.3431 6.34315C14.3622 5.32406 15.6279 4.60831 17 4.25401C17.6479 4.08671 18.3195 4 19 4V4.00108V6V6.00108C17.409 6.00108 15.8831 6.63311 14.7581 7.75812C13.6331 8.88314 13.0011 10.409 13.0011 12C13.0011 13.591 13.6331 15.1169 14.7581 16.2419C15.8831 17.3669 17.409 17.9989 19 17.9989V18L19 19.9989V20C18.3195 20 17.6479 19.9133 17 19.746C15.6279 19.3917 14.3622 18.6759 13.3431 17.6569C13.2246 17.5383 13.1102 17.4165 13 17.2915V22H11V17.2915C10.8898 17.4165 10.7754 17.5383 10.6569 17.6569C9.63777 18.6759 8.37206 19.3917 7 19.746C6.35212 19.9133 5.68053 20 5 20V19.9989V18V17.9989C6.59101 17.9989 8.11686 17.3669 9.24188 16.2419C10.3669 15.1169 10.9989 13.591 10.9989 12C10.9989 10.409 10.3669 8.88314 9.24188 7.75812C8.11686 6.6331 6.59102 6.00108 5 6.00108L5 6L5 4.00108L5 4C5.68053 4 6.35212 4.08671 7 4.25401C8.37206 4.60831 9.63777 5.32406 10.6569 6.34315C10.7754 6.46166 10.8898 6.58351 11 6.70848V2Z'
    },
    _f);
exports.signs = (_g = {},
    _g[defs_1.SignType.Aries] = {
        en: 'Aries',
        ru: "chronos.auth.planets.mars.sign",
        icon: 'M64-34.82c0,7.26-2.29,15.08-6.81,23.46H47.67c4.62-8.29,6.95-15.87,6.95-22.85,0-5.58-1.21-10.07-3.59-13.54a11.2,11.2,0,0,0-9.56-5.15c-8.44,0-16.33,9.46-23.6,28.29C14.13-15,11.06-2.55,8.49,12.76A260.24,260.24,0,0,0,4.71,54.87v5.9H-4.66V54.49a253.72,253.72,0,0,0-3.6-40.14q-3.63-22.12-8.81-36.1Q-28.41-52.11-41.47-52.1A11.27,11.27,0,0,0-51-47c-2.42,3.42-3.63,7.82-3.63,13.3,0,7.22,2.28,14.66,6.95,22.34h-9.47Q-64-23.79-64-34.63c0-7.5,2.15-13.68,6.44-18.64a20.54,20.54,0,0,1,16.18-7.5c10.5,0,19.36,7.07,26.73,21.27S-2.71-6.44-.79,17.4H.79q2.38-35,13.62-56.58c7.47-14.38,16.52-21.59,27-21.59a20.51,20.51,0,0,1,16.14,7.4Q64-46.06,64-34.82Z',
        element: 'fire'
    },
    _g[defs_1.SignType.Taurus] = {
        en: 'Taurus',
        ru: "chronos.app.instruments.widgets.prompts.signs.taurus.name",
        icon: 'M56.34-64c-8.72,0-16.69,6.16-23.77,18.44L27-36c-3.64,6.26-7.43,10.63-11.42,13.12S6.45-19.11,0-19.11s-11.61-1.25-15.59-3.78S-23.35-29.75-27-36l-5.43-9.55Q-43.17-64-56.34-64h-4.94v7.46h1.8c6.18,0,11.76,4.37,16.64,13.12l4,7.16q5,9,9.12,13A32.12,32.12,0,0,0-19-16.58,47.81,47.81,0,0,0-36.71-.27,40.07,40.07,0,0,0-43,21.5q0,17.14,12.86,29.82C-21.56,59.77-11.54,64,0,64s21.59-4.23,30.16-12.68S42.94,32.93,42.94,21.5A40,40,0,0,0,36.71-.27,47.81,47.81,0,0,0,19-16.58a32.63,32.63,0,0,0,10.77-6.66q4.11-4,9.12-13l4-7.16c4.88-8.75,10.46-13.12,16.69-13.12h1.75V-64Zm-33,62.68A31.31,31.31,0,0,1,33,21.75,30.63,30.63,0,0,1,23.3,44.51,31.92,31.92,0,0,1,0,54a31.87,31.87,0,0,1-23.32-9.5A30.63,30.63,0,0,1-33,21.75,31.31,31.31,0,0,1-23.35-1.32,32.09,32.09,0,0,1,0-10.81,31.74,31.74,0,0,1,23.35-1.32Z',
        element: 'land'
    },
    _g[defs_1.SignType.Gemini] = {
        en: 'Gemini',
        ru: "chronos.app.instruments.widgets.prompts.signs.gemini.name",
        icon: 'M62.3-54.51V-64Q36.92-57,0-56.94T-62.3-64v9.49a158.54,158.54,0,0,0,29.22,5.59V48.76A215.61,215.61,0,0,0-62.3,54.57V64Q-33.44,56.38,0,56.43T62.3,64V54.57A218.17,218.17,0,0,0,33,48.76V-48.92A160,160,0,0,0,62.3-54.51ZM21.69,48.08A193.17,193.17,0,0,0,0,47a192.86,192.86,0,0,0-21.71,1.08V-48.13c5.81.39,13,.62,21.71.62s15.85-.23,21.72-.62Z',
        element: 'air'
    },
    _g[defs_1.SignType.Cancer] = {
        en: 'Cancer',
        ru: "chronos.auth.planets.moon.sign",
        icon: 'M7.72-50.13C-12.82-50.13-30-46.44-43.56-39S-64-22.32-64-11.14A24.44,24.44,0,0,0-56.55,6.79a24.21,24.21,0,0,0,17.89,7.44A24.89,24.89,0,0,0-20.52,6.74a24.53,24.53,0,0,0,7.55-18,24.73,24.73,0,0,0-3.85-13.94A28.06,28.06,0,0,0-28.36-35C-20.27-38.45-9.77-40.1,3-40.1q29.48,0,61,14.38V-36.6Q34.39-50.16,7.72-50.13Zm-33,25.56a17.89,17.89,0,0,1,5.6,13.24A18.17,18.17,0,0,1-25.22,2,18.11,18.11,0,0,1-38.56,7.54,17.81,17.81,0,0,1-51.8,2a18.5,18.5,0,0,1-5.5-13.48,17.93,17.93,0,0,1,5.4-13.19,18,18,0,0,1,13.19-5.39A18.65,18.65,0,0,1-25.27-24.57ZM38.61-14.18A24.78,24.78,0,0,0,20.52-6.69a24.58,24.58,0,0,0-7.6,18,25.13,25.13,0,0,0,3.85,13.94A28.9,28.9,0,0,0,28.26,35.1q-12.06,5-31.33,5-29.4,0-60.93-14.33V36.65c19.74,9,38.48,13.48,56.28,13.48q30.81,0,51.28-11.08T64,11.24a24.55,24.55,0,0,0-7.45-18A24.59,24.59,0,0,0,38.61-14.18Zm13.24,38.9a18.34,18.34,0,0,1-13.24,5.39,18.27,18.27,0,0,1-13.34-5.54,17.86,17.86,0,0,1-5.6-13.19,18.16,18.16,0,0,1,5.5-13.33A18.22,18.22,0,0,1,38.56-7.49,17.89,17.89,0,0,1,51.8-1.95a18.45,18.45,0,0,1,5.45,13.48A17.93,17.93,0,0,1,51.85,24.72Z',
        element: 'water'
    },
    _g[defs_1.SignType.Leo] = {
        en: 'Leo',
        ru: "chronos.auth.planets.sun.sign",
        icon: 'M44.54,47.91c-5.69,5-10.77,7.55-15.2,7.55A10.71,10.71,0,0,1,21,51.92a12.55,12.55,0,0,1-3.26-9c0-4.94,3.92-15.76,11.66-32.56L33.77.93c3.91-8.44,6.43-14.5,7.46-18.19a46.88,46.88,0,0,0,1.58-13.06q0-15.26-9.46-24.49T8.16-64Q-6.1-64-15.62-55.28A28.33,28.33,0,0,0-25-33.49q0,10.07,6.8,23.13a26.55,26.55,0,0,0-7.83-1.3A22.84,22.84,0,0,0-42.95-4.43,23.51,23.51,0,0,0-50,12.73a23.83,23.83,0,0,0,7.18,17.54,23.58,23.58,0,0,0,17.4,7.19A23.84,23.84,0,0,0-8.21,30.32,22.89,22.89,0,0,0-.89,13.53c0-4.06-2-10.26-6.15-18.75l-2.47-5.14q-6.16-12.87-6.16-22.53c0-7,2.19-12.54,6.58-16.88s10.16-6.39,17.3-6.39c7.6,0,13.71,2.38,18.33,7.23s6.9,11.15,6.9,19.08c0,6.2-2.33,14.32-7,24.3L20.38,7.37Q8.49,32.63,8.49,43.94a19.33,19.33,0,0,0,5.87,14.28A20.19,20.19,0,0,0,29,64q10.06,0,21-10.08ZM-13.66.42a17.26,17.26,0,0,1,5,12.5,17,17,0,0,1-5,12.41,16.41,16.41,0,0,1-12.13,5.13,16.53,16.53,0,0,1-12.22-5.08,17.38,17.38,0,0,1-5-12.55,17.07,17.07,0,0,1,5-12.36A16.38,16.38,0,0,1-25.93-4.66,16.69,16.69,0,0,1-13.66.42Z',
        element: 'fire'
    },
    _g[defs_1.SignType.Virgo] = {
        en: 'Virgo',
        ru: "chronos.app.instruments.widgets.prompts.signs.virgo.name",
        icon: 'M46.41,20.59a59.51,59.51,0,0,0,6.36-27q0-18.16-10.64-34.63l-8.24,3c-3,4.26-5.87,10.27-8.55,17.86V-39.14A41.42,41.42,0,0,0,17.24-64L7.6-62.16A61.59,61.59,0,0,0-4.57-41.08Q-6.35-55.36-13.07-64l-9.79,1.84q-6.63,7.29-11.72,19.69c-1.39-8-3.93-14.58-7.65-19.69H-52.77a47.86,47.86,0,0,1,8.2,27.28V37.41h10V-25C-31-36.81-25.89-46.69-19-54.72c2.88,4.81,4.37,13.39,4.37,25.75V37.41h10V-22.67c3.38-13.75,8.59-24.46,15.65-32,2.88,5.06,4.27,12.5,4.27,22.37V28.18a80.93,80.93,0,0,0,1,13C10.93,44.4,4,46.93-4.57,48.67V57.2Q9,55,18.33,49.76A51.81,51.81,0,0,0,25.89,64H37.61Q28.52,52.92,27.33,44.16C35.77,36.86,42.18,29,46.41,20.59ZM25.34,34.83V-4.71C28.57-14.88,32.59-23,37.56-29.12A54.52,54.52,0,0,1,42.78-5.9a55,55,0,0,1-4.32,21.63A62.52,62.52,0,0,1,25.34,34.83Z',
        element: 'land'
    },
    _g[defs_1.SignType.Libra] = {
        en: 'Libra',
        ru: "chronos.app.instruments.widgets.prompts.signs.libra.name",
        icon: 'M-64,41.63H64V53.48H-64ZM28.59,5.92q9.69-9.85,9.67-22.15c0-10.18-3.74-18.89-11.33-26.23a37.19,37.19,0,0,0-26.87-11,37.23,37.23,0,0,0-26.93,11C-34.4-35.12-38.2-26.41-38.2-16.23-38.2-8-35-.65-28.53,5.92H-64V17.83h50.6V6.75C-22,1.18-26.28-6.28-26.28-15.63a24.69,24.69,0,0,1,7.77-18.24A25.26,25.26,0,0,1,.06-41.57a25.41,25.41,0,0,1,18.51,7.7,24.69,24.69,0,0,1,7.77,18.24C26.34-6.28,22,1.18,13.41,6.75V17.83H64V5.92Z',
        element: 'air'
    },
    _g[defs_1.SignType.Scorpio] = {
        en: 'Scorpio',
        ru: "chronos.auth.planets.pluto.sign",
        icon: 'M42.64,64V54.43h-9c-8.62,0-14.84-2.25-18.71-6.77S9.06,35.89,9.06,25.93V-33.39c0-10-1.42-17.17-4.31-21.53C-2.59-46.44-7.74-35.84-10.58-23.08V36.38h-9.84V-29.9q0-17.88-4.3-25c-7,7.94-12.15,17.85-15.38,29.63V36.38h-9.84V-33.88c0-11.67-2.74-21.14-8.27-28.21h10.57A51.87,51.87,0,0,1-40.1-42.71,67.52,67.52,0,0,1-28.54-62.09L-19-64c4.46,5.2,7.25,12.66,8.47,22.32A67.21,67.21,0,0,1,1.27-62.09L11-64q7.92,10.74,7.93,25.46V22.79a91,91,0,0,0,.63,13.05,12.43,12.43,0,0,0,3,6c2.79,3,7.49,4.42,14,4.42h6V36.38L58.21,50.46Z',
        element: 'water'
    },
    _g[defs_1.SignType.Sagittarius] = {
        en: 'Sagittarius',
        ru: "chronos.auth.planets.jupiter.sign",
        icon: 'M64,4.47,52,6.35l-6.18-43.8L-9.06,17.65,16.77,43.47,8.16,52.09-17.68,26.21-55.63,64-64,55.62l37.9-37.85L-51.87-8.11l8.49-8.63L-17.55,9.14l55-55L-6.28-52-4.4-64l60,8.38Z',
        element: 'fire'
    },
    _g[defs_1.SignType.Capricorn] = {
        en: 'Capricorn',
        ru: "chronos.auth.planets.saturn.sign",
        icon: 'M56.8-1.74a24,24,0,0,0-17.39-7q-17,0-26.62,18.42a88.67,88.67,0,0,1-3-16.53Q9.46-9.58,8.57-16L6.73-28.15q-3.21-22-8-32.93l-13.16,2.54q-13.26,15.7-18.87,41-4-22.93-8.7-32.82c-2.68-5.46-7.5-8.19-14.5-8.19H-64v8.19h1.89c5.86,0,10.13,2.63,12.86,7.84q2.91,5.52,6.31,23.24C-40.7-7.45-39.56,1.64-39.56,8.14v3.48h9.93V6.26c0-9,2-19.27,6.21-30.74s9-20.56,14.7-27.26q3.36,7.08,5.81,25.92L-.37-6.75c1.09,8.93,2,14.69,2.68,17.33a44.36,44.36,0,0,0,4.42,9.88c-5,14.65-9.09,23.68-12.27,27.11s-9.09,5.21-17.63,5.21h-4.22v8.3h9q13.26,0,19.07-5.52T14.13,30.09q10.65,11,24.89,11a23.78,23.78,0,0,0,17.73-7.49A25.38,25.38,0,0,0,64,15.34,22.88,22.88,0,0,0,56.8-1.74ZM50.74,28.45a16.57,16.57,0,0,1-12.47,5.22c-7.35,0-14.7-4-21.9-12q8.34-22.86,23-22.89A15.54,15.54,0,0,1,50.94,3.62a16.46,16.46,0,0,1,4.77,11.87A17.88,17.88,0,0,1,50.74,28.45Z',
        element: 'land'
    },
    _g[defs_1.SignType.Aquarius] = {
        en: 'Aquarius',
        ru: "chronos.auth.planets.uranus.sign",
        icon: 'M51.56,10.32,64,39.43l-8,3.54L47.65,23.21,17.53,43,9.15,23.21-20.72,43l-8.43-19.76L-59.27,43-64,35.84l38.71-25.52,8.48,19.77,30-19.77,8.38,19.77ZM-29-30.09l8.32,19.77L9.15-30.09l8.38,19.77L47.7-30.09,56-10.32l8-3.54L51.61-43l-30,19.76L13.26-43l-30,19.76L-25.24-43-63.95-17.4l4.78,7.08Z',
        element: 'air'
    },
    _g[defs_1.SignType.Pisces] = {
        en: 'Pisces',
        ru: "chronos.auth.planets.neptune.sign",
        icon: 'M24.72,2q0,33.72,26.85,62H38.33A108.12,108.12,0,0,1,19.56,33.81c-4.62-11.18-7-21.81-7-31.84H-12.57c0,10-2.37,20.66-7,31.84A109.34,109.34,0,0,1-38.27,64h-13.3Q-24.69,35.67-24.72,2H-50.66V-7.14h25.94Q-26.37-36.48-51.57-64H-39Q-15.85-39.31-12.57-7.14H12.57Q15.95-39.3,39-64H51.57Q26.34-36.47,24.72-7.14H50.66V2Z',
        element: 'water'
    },
    _g);
exports.aspects = (_h = {},
    _h[defs_1.AspectType.Conjunction] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.conjunction.name",
        en: 'Conjunction',
        icon: 'M53.27 12.78L50.4 10 35.82 25a15.41 15.41 0 0 0-9.32-3.14 16.1 16.1 0 0 0 0 32.2 16 16 0 0 0 15.77-16.1 16.21 16.21 0 0 0-3.57-10.23zM26.5 50a12.1 12.1 0 0 1 0-24.2 12.1 12.1 0 0 1 0 24.2z'
    },
    _h[defs_1.AspectType.Semisextile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.semisextile.name",
        en: 'Semisextile',
        icon: 'M48.88 24.38H15.12v4h12.03l-8.35 8.27 2.81 2.85 10.4-10.31 10.52 10.43 2.82-2.84-8.48-8.4h12.01v-4z'
    },
    _h[defs_1.AspectType.Semiquintile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.semiquintile.name",
        en: 'Semiquintile',
        icon: 'M11 4L11 18H5V20H19V18H13L13 4H11Z'
    },
    _h[defs_1.AspectType.Novile] = {
        ru: "chronos.app.aspects.novile",
        en: 'Novile',
        icon: 'M47 53.8L16.6 16.5v37.2h-4V10h3.5l31.3 38.3v-37h4v42.5z'
    },
    _h[defs_1.AspectType.Semisquare] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.semisquare.name",
        en: 'Semisquare',
        icon: 'M47.83 45.89H16.17l15.81-27.78 3.48 1.98-12.41 21.8h24.78v4z'
    },
    _h[defs_1.AspectType.Sextile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.sextile.name",
        en: 'Sextile',
        icon: 'M48.88 30H36.84l8.51-8.51-2.83-2.83-8.51 8.52V15.13h-4v12.05l-8.39-8.39-2.83 2.82L27.18 30H15.12v4.01h12.06l-8.53 8.52 2.83 2.83 8.53-8.53v12.04h4V36.83l8.4 8.4 2.83-2.82-8.4-8.4h12.04V30z'
    },
    _h[defs_1.AspectType.Quintile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.quintile.name",
        en: 'Quintile',
        icon: 'M53,30.91a20.55,20.55,0,1,0-13.66,19.3l7.6,7.59L49.74,55l-6.59-6.59A20.44,20.44,0,0,0,53,30.91ZM32.5,47.4a16.52,16.52,0,1,1,7.73-1.94l-5.82-5.82-2.83,2.83L36.1,47A16.41,16.41,0,0,1,32.5,47.4Z'
    },
    _h[defs_1.AspectType.Binovile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.binovile.name",
        en: 'Binovile',
        icon: 'M42.2 53.9L11.8 16.6v37.2h-4V10.1h3.5l31.3 38.3v-37h4v42.5zM50.7 20.3v-1.5l3.2-2.8c.3-.3.6-.6.8-.9.2-.3.3-.6.3-.9 0-.4-.1-.6-.4-.8s-.5-.3-.9-.3-.7.1-.9.3c-.2.2-.3.5-.3.9h-2c0-.6.1-1.1.4-1.5.3-.4.7-.8 1.1-1s1.1-.4 1.7-.4c.7 0 1.2.1 1.7.4.5.2.8.6 1.1 1s.4.9.4 1.4c0 .4-.1.8-.2 1.1-.1.3-.4.7-.7 1-.3.4-.7.8-1.3 1.2l-1.1 1v.1H57v1.7h-6.3z'
    },
    _h[defs_1.AspectType.Square] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.square.name",
        en: 'Square',
        icon: 'M44.5 19.5v25h-25v-25h25m4-4h-33v33h33v-33z'
    },
    _h[defs_1.AspectType.MinusOrPlus] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.minusOrPlus.name",
        en: 'MinusOrPlus',
        icon: 'M54.9 11.6v-4H9.1v4H30v16H9.1v4H30v23.9h4V31.6h20.9v-4H34v-16z'
    },
    _h[defs_1.AspectType.Tredecile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.tredecile.name",
        en: 'Tredecile',
        icon: 'M52 49H35V33H45V29H35V10H31V29H21V33H31V49H14V53L52 53V49Z'
    },
    _h[defs_1.AspectType.Trine] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.trine.name",
        en: 'Trine',
        icon: 'M32 24.31l11.11 19.45H20.89L32 24.31m0-8.07L14 47.76h36L32 16.24z'
    },
    _h[defs_1.AspectType.Sesquiquadrate] = {
        ru: "astro.sesquiquadrate",
        en: 'Sesquiquadrate',
        icon: 'M45.5 41.29v-27h-27v27h7.64l-3.64 8.29 14 .13v-4l-7.92-.07 1.91-4.35zm-23-4v-19h19v19h-9.24l3.82-8.7L32.42 27 27.9 37.29z'
    },
    _h[defs_1.AspectType.Biquintile] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.biquintile.name",
        en: 'Biquintile',
        icon: 'M35 49H52V53L14 53V49H31L31 10H35L35 49Z'
    },
    _h[defs_1.AspectType.Quincunx] = {
        ru: "astro.quincunx",
        en: 'Quincunx',
        icon: 'M48.88 24.38H15.12v4h12.03l-8.35 8.27 2.81 2.85 10.4-10.31 10.52 10.43 2.82-2.84-8.48-8.4h12.01v-4z'
    },
    _h[defs_1.AspectType.Opposition] = {
        ru: "chronos.app.instruments.widgets.prompts.aspects.opposition.name",
        en: 'Opposition',
        icon: 'M42.13 11A10.11 10.11 0 0 0 32 21.09a10 10 0 0 0 2.06 6.09l-6.86 7.15a10.1 10.1 0 1 0 2.92 2.73l6.94-7.23A10.1 10.1 0 1 0 42.13 11zM21.87 49A6.1 6.1 0 1 1 28 42.91 6.11 6.11 0 0 1 21.87 49zm20.26-21.81a6.1 6.1 0 1 1 6.12-6.1 6.12 6.12 0 0 1-6.12 6.1z'
    },
    _h);
exports.prognosticsModes = ['directions', 'solars', 'transits', 'prog_natal', 'prog_prog'];
exports.relocationsModes = ['relocation_natal', 'relocation1', 'relocation2', 'relocation3', 'relocation4', 'relocation5', 'relocation6', 'relocation7', 'relocation8', 'relocation9'];
exports.synastryModes = ['syn_natal', 'compatibility', 'partner1', 'partner2'];
exports.planets = [
    defs_1.ObjectType.Sun,
    defs_1.ObjectType.Moon,
    defs_1.ObjectType.Mercury,
    defs_1.ObjectType.Venus,
    defs_1.ObjectType.Mars,
    defs_1.ObjectType.Jupiter,
    defs_1.ObjectType.Saturn,
    defs_1.ObjectType.Uranus,
    defs_1.ObjectType.Neptune,
    defs_1.ObjectType.Pluto
];
